import React, {useEffect, useState} from "react";
import PageTitle from "./include/PageTitle";
import Projects from "./include/Project";
import {get_projects} from "../Utils/Data";
import {Helmet} from "react-helmet";

function Project({title}) {
    const [projects, setProjects] = useState([]);


    useEffect(() => {
        const fetchProjects = async () => {
            const data = await get_projects();
            if(data){
            setProjects(data);
            }
        };
        fetchProjects();
    }, []);

    return (
        <>
            <Helmet>
                <title>Zaala | Project</title>
            </Helmet>
            <PageTitle title={title}/>

            <section className="project-one">
                <div className="container-fluid">
                    <div className="section-title text-center tg-heading-subheading animation-style2">
                        <h5 className="tg-element-title" style={{perspective: 400}}>
                            <div
                                className="split-line"
                                style={{
                                    display: "block",
                                    textAlign: "center",
                                    position: "relative"
                                }}
                            >
                                <div style={{position: "relative", display: "inline-block"}}>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        l
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        a
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        t
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        e
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        s
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        t
                                    </div>
                                </div>
                                {" "}
                                <div style={{position: "relative", display: "inline-block"}}>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        p
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        o
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        r
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        t
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        f
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        o
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        l
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        i
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        o
                                    </div>
                                </div>
                            </div>
                        </h5>
                        <h2 className="tg-element-title" style={{perspective: 400}}>
                            <div
                                className="split-line"
                                style={{
                                    display: "block",
                                    textAlign: "center",
                                    position: "relative"
                                }}
                            >
                                <div style={{position: "relative", display: "inline-block"}}>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        W
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        h
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        e
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        r
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        e
                                    </div>
                                </div>
                                {" "}
                                <div style={{position: "relative", display: "inline-block"}}>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        I
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        n
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        n
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        o
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        v
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        a
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        t
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        i
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        o
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        n
                                    </div>
                                </div>
                                {" "}
                                <div style={{position: "relative", display: "inline-block"}}>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        M
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        e
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        e
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        t
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        s
                                    </div>
                                </div>
                                {" "}
                            </div>
                            <div
                                className="split-line"
                                style={{
                                    display: "block",
                                    textAlign: "center",
                                    position: "relative"
                                }}
                            >
                                <div style={{position: "relative", display: "inline-block"}}>
                                    {" "}
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        I
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        T
                                    </div>
                                </div>
                                {" "}
                                <div style={{position: "relative", display: "inline-block"}}>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        E
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        x
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        c
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        e
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        l
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        l
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        e
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        n
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        c
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        e
                                    </div>
                                </div>
                            </div>
                        </h2>
                    </div>
                    <div className="row project-one__gap mx-4">
                        {/*Start Project One Single */}
                        <Projects data={projects}/>
                        {/*End Project One Single */}
                    </div>
                </div>
            </section>

        </>
    );
}

export default Project;
